const {KitModule, registerModule} = window;

class Outline extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.$content = document.querySelectorAll('.post-text > *');
    this.$outline = document.getElementsByClassName('post-outline')[0];
    this.$outlineLinks = document.querySelectorAll('.post-outline a');

    this.observer = this.observerSetup();
  }

  bindEvents() {
    this.$content.forEach(($elem) => this.observer.observe($elem));
  }

  observerSetup() {
    return new IntersectionObserver(
      ($entries) => {
        $entries.forEach(($entry) => {
          if ($entry.isIntersecting) {
            // Get nearest Heading
            let currElem = $entry.target;
            let isHeading = currElem.tagName === 'H3' || currElem.tagName === 'H2' || currElem.tagName === 'H1';
            let prevSibling = currElem.previousElementSibling;
            while (!isHeading && prevSibling) {
              currElem = prevSibling;
              isHeading = currElem.tagName === 'H3' || currElem.tagName === 'H2' || currElem.tagName === 'H1';
              prevSibling = currElem.previousElementSibling;
            }
            if (!isHeading) {
              return;
            }
            const headingId = currElem.id;

            // Find the highest content element that is visible before the heading found above.
            const $content = Array.from(this.$content);
            let currElemIndex = $content.findIndex((elem) => elem.id === headingId);
            let isVisible = true;
            while (isVisible && currElemIndex > 0) {
              const elemToCheck = $content[currElemIndex - 1];
              const rect = elemToCheck?.getBoundingClientRect();
              // 0, but add 100 for buffer for top nav
              if (!rect || rect.top < 105 || rect.bottom > window.innerHeight) {
                isVisible = false;
              } else {
                currElemIndex--;
              }
            }

            // Once again, look for the nearest heading
            if (currElemIndex >= 0) {
              let currElem = $content[currElemIndex];
              let isHeading = currElem.tagName === 'H3' || currElem.tagName === 'H2' || currElem.tagName === 'H1';
              let prevSibling = currElem.previousElementSibling;
              while (!isHeading && prevSibling) {
                currElem = prevSibling;
                isHeading = currElem.tagName === 'H3' || currElem.tagName === 'H2' || currElem.tagName === 'H1';
                prevSibling = currElem.previousElementSibling;
              }
              if (!isHeading) {
                return;
              }
              const headingId = currElem.id;

              // Now set the heading that should be marked as is-active
              const outlineLinks = Array.from(this.$outlineLinks);
              const matchingLink = outlineLinks.find((link) => link.getAttribute('href') === `#${headingId}`);
              if (matchingLink) {
                // Clear existing is-active
                this.$outline.querySelector('.is-active')?.classList.remove('is-active');

                matchingLink.classList.add('is-active');
              }
              return;
            }
          }
        });
      },
      {
        // Account for the space that the top nav takes
        rootMargin: '-105px 0px 0px 0px',
        threshold: [0, 1],
      },
    );
  }

  unmount() {
    this.$content.forEach(($elem) => this.observer.unobserve($elem));
  }
}

registerModule('Outline', Outline);
